// Utility functions for project navigation and data handling

export const generateSlug = (title) => {
  return title
    .toLowerCase()
    .replace(/[^\w\s-]/g, '') // Remove special characters
    .replace(/\s+/g, '-') // Replace spaces with hyphens
    .trim();
};

export const getProjectBySlug = (projects, slug) => {
  return projects.find(project => project.slug === slug);
};

export const getNextProject = (projects, currentId) => {
  const currentIndex = projects.findIndex(p => p.id === currentId);
  return currentIndex < projects.length - 1 ? projects[currentIndex + 1] : projects[0];
};

export const getPreviousProject = (projects, currentId) => {
  const currentIndex = projects.findIndex(p => p.id === currentId);
  return currentIndex > 0 ? projects[currentIndex - 1] : projects[projects.length - 1];
};

export const formatDuration = (duration) => {
  return duration;
};

export const getStatusColor = (status) => {
  switch (status) {
    case "Completed": 
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300";
    case "In Progress": 
      return "bg-yellow-100 text-yellow-800 dark:bg-yellow-900 dark:text-yellow-300";
    default: 
      return "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300";
  }
};

export const getCategoryColor = (category) => {
  switch (category) {
    case "business":
      return "bg-blue-100 text-blue-800 dark:bg-blue-900 dark:text-blue-300";
    case "analysis":
      return "bg-purple-100 text-purple-800 dark:bg-purple-900 dark:text-purple-300";
    case "case":
      return "bg-green-100 text-green-800 dark:bg-green-900 dark:text-green-300";
    case "prediction":
      return "bg-orange-100 text-orange-800 dark:bg-orange-900 dark:text-orange-300";
    default:
      return "bg-gray-100 text-gray-800 dark:bg-gray-900 dark:text-gray-300";
  }
};